<template>
  <Layout>
    <PageHeader :title="title" />
    <!-- <div class="row">
      <div class="col-2"></div>
      <div class="col-8">
          <div class="dataTables_filter text-md-left">
              <label class="d-inline-flex align-items-center width-300">
                  <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control"
                  ></b-form-input>
              </label>
          </div> 
          <b-input-group class="mb-3 cursor-pointer" v-b-toggle.my-categories>
            <template #append>
              <b-input-group-text>
                <i class="mdi mdi-menu-down" style="line-height: 1;"></i>
              </b-input-group-text>
            </template>
            <b-form-input v-model="valueText" readonly></b-form-input>
          </b-input-group>
      </div>
      <div class="col-2"></div>
    </div> -->
    <div class="row">
      <div class="col-12" v-if="categorySelector.isSuccess"> Result selected: {{ categorySelector.valueSelected }}</div>
    </div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8" v-if="isMenuItems">
            <CatelogSelector 
            :level="3" 
            :displayKey="`display_name.en`" 
            :idKey="`view_id`" 
            :childrenItemsKey="`items`"
            :items="menuItems"
            @result="resultCategorySelector"></CatelogSelector>
      </div>
      <div class="col-2"></div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <button type="button" class="btn btn-success" style="padding: 5px;" @click="submit">Submit for form</button>
      </div>
    </div>
  </Layout>
</template>
<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CatelogSelector from "@/components/global/category-selector";
import authorizeProvider from "@/helpers/service/authorize-provider";
export default {
  components: {
    Layout,
    PageHeader,
    CatelogSelector
  },
  data() {
    return {
      title: "Category",
      menuItems: [],
      categorySelector: {
        isSuccess: false,
        valueSelected: []
      }
    }
  },
  computed: {
    
  },
  beforeMount() {},
  mounted() {
    this.onGetMenuItems()
  },
  methods: {
    isMenuItems() {
      return this.$validate.anyArrayObjectValid(this.menuItems)
    },
    async onGetMenuItems() {
      // const responsed = await authorizeProvider.getMenuItems("fdefd");
      var accessToken = this.$cookies.get(".at");
        //console.log('accessTokenssssssss',accessToken);
      const responsed = await authorizeProvider.getMenuItems(accessToken);

      //console.log('menu', this.menuItems)
      
      if (responsed.status == 200) {
        this.menuItems = responsed.data;
        //console.log('menu', this.menuItems);
      } else if (responsed.status == 404) console.log("ไม่มีสิทธิ์");
    },
    resultCategorySelector(obj) {
      //console.log(obj)
      this.categorySelector.isSuccess = obj.isSuccess
      this.categorySelector.valueSelected = obj.value
    },
    submit() {
      Vue.swal({
        position: "top-end",
        icon: this.categorySelector.isSuccess ? "success" : "error",
        title: this.categorySelector.isSuccess ? "สำเร็จ" : "ไม่สำเร็จ",
        showConfirmButton: false,
        timer: 1500,
      });
    }
  }
};
</script>
<style>
.table > tbody > tr.active {
  background-color: #a9efbb5e;
}
</style>